<template>
  <div>
    <MasterLayout>
      <div class="mobile__bg"></div>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.cDisconnectedPumps.title") }}
              </h3>
              <div class="mt-3 company__icon__wrapper">
                <div class="text-center company__icon__div">
                  <div>
                    <img src="@/assets/img/pump_icon.png" width="80%" />
                  </div>
                </div>
              </div>
              <div class="mt-3 text-center">
                <h3>{{ offlinePumps }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mr-3 fuelbalance_first_row_right_section co_company"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="text-center col-md-6 section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.cDisconnectedPumps.title") }}
                </h3>
              </div>
              <div class="text-right col-md-6 section___column_2"></div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 section_2">
        <div class="">
          <div class="section_2_table_section">
            <div class="row">
              <div class="col-md-7">
                <div class="table_label_div">
                  <div class=""></div>
                </div>
              </div>
              <div class="text-right col-md-5">
                <div class="mt-3 ml-5 search_div">
                  <!-- <input type="search" placeholder="Search table list ..." /> -->
                </div>
              </div>
            </div>
            <!-- :dataBound="dataBound" -->
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="deviceId"
                  :headerText="$t('text.cDisconnectedPumps.deviceId')"
                ></e-column>
                <e-column
                  width="160"
                  field="pumps"
                  :headerText="$t('text.cDisconnectedPumps.pump')"
                ></e-column>
                <e-column
                  field="branchName"
                  width="160"
                  :headerText="$t('text.cDisconnectedPumps.branchName')"
                ></e-column>
                <e-column
                  width="260"
                  field="date"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.cDisconnectedPumps.date')"
                ></e-column>
                <e-column width="200" :template="template"></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import Temp from "@/components/Templates/disconnected_pumps_temp";
import JQuery from "jquery";
let $ = JQuery;
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Disconnected Pumps :: Epump Portal",
  name: "OfflinePumps",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      formatOptions: { type: "dateTime", format: "dd/MM/yyyy hh:mm a" },
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      offlinePumps: 0,
      company: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      template: function () {
        return {
          template: Temp,
        };
      },
    };
  },

  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getOfflinePumps();
    }
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getOfflinePumps();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getOfflinePumps() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/OfflinePump/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.branchName > b.branchName
              ? 1
              : b.branchName > a.branchName
              ? -1
              : 0;
          });
          response.data.forEach((offline, index) => {
            offline.index = index + 1;
          });
          this.showLoader = false;
          this.offlinePumps = response.data.length;
          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
